export default __webpack_public_path__ + "static/media/Screenshot_7.88818139.png";